import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SolarPowerMgtService } from 'app/shared/services/solar-power-mgt.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';

@Component({
  selector: 'ngx-solar-power',
  templateUrl: './solar-power.component.html',
  styleUrls: ['./solar-power.component.scss']
})
export class SolarPowerComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  solarPowerData =[];

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;
  solarPowerForm: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  
  validationMessages = {
    'refCode' : { 'required': 'This field is required' },
    'fromDate' : { 'required': 'This field is required' },
    'fromTime' : { 'required': 'This field is required' },
    'fromSunbirdMR' : { 'required': 'This field is required' },
    'fromEBMRExport' : { 'required': 'This field is required' },
    'fromEBMRConsume' : { 'required': 'This field is required' },
    'toDate' : { 'required': 'This field is required' },
    'toTime' : { 'required': 'This field is required' },
    'toSunbirdMR' : { 'required': 'This field is required' },
    'toEBMRExport' : { 'required': 'This field is required' },
    'toEBMRConsume' : { 'required': 'This field is required' },
    'productionDiff' : { 'required': 'This field is required' },
    'exportDiff' : { 'required': 'This field is required' },
    'consumeDiff' : { 'required': 'This field is required' },
    'netExportOrConsume' : { 'required': 'This field is required' },
  
  };

  formErrors = {
    'refCode' : "",
    'fromDate' : "",
    'fromTime' : "",
    'fromSunbirdMR' : "",
    'fromEBMRExport' : "",
    'fromEBMRConsume' : "",
    'toDate' : "",
    'toTime' : "",
    'toSunbirdMR' : "",
    'toEBMRExport' : "",
    'toEBMRConsume' : "",
    'productionDiff' : "",
    'exportDiff' : "",
    'consumeDiff' : "",
    'netExportOrConsume' : "",


  };




    constructor(private fb: FormBuilder,
                private solarPowerMgtService: SolarPowerMgtService,
                private fileUploadService:FileUploadService,
                private authService: AuthService,
                private toastr: ToastrService,
                private router : Router, 
                private themeService: NbThemeService,
                private dialogService: DialogService
              ) {
                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
              }
              
               

              

  ngOnInit() {
      
    this.solarPowerForm = this.fb.group({
      id : [null],
      refCode: ['',Validators.required],
      fromDate: ['',Validators.required],
      fromTime: ['',Validators.required],
      fromSunbirdMR: ['',Validators.required],
      fromEBMRExport: ['',Validators.required],
      fromEBMRConsume: ['',Validators.required],
      toDate: ['',Validators.required],
      toTime: ['',Validators.required],
      toSunbirdMR: ['',Validators.required],
      toEBMRExport: ['',Validators.required],
      toEBMRConsume: ['',Validators.required],
      productionDiff: ['',Validators.required],
      exportDiff: ['',Validators.required],
      consumeDiff: ['',Validators.required],
      netExportOrConsume: ['',Validators.required],
      roomDetails: [''],
      totalGuest: [''],
      createdBy: [''],


    });

  
   this.solarPowerForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.solarPowerForm);
  });


    this.getDataTableRowData();
   this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  } /////// end onInit

  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='SP'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  getAll(){
    this.solarPowerMgtService.getPreviuosData()
     .subscribe(
        (data) => {
                  this.solarPowerData = data;
                  this.getPreviousData();
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.solarPowerForm.value.guestId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.getAll();
    this.isShowAttachBtn=false; 
    this.isSaveBtnDisabled = false;
    this.solarPowerForm.reset();
    this.enableForm();
    this.getMaxId();
    
   }

   
  
   getMaxId(){
    var customerId = 0;
    var sCustomerId : String;
  
    this.solarPowerMgtService.getMaxId()
    .subscribe(
      (res) => {
                  customerId = Number(res[0].MaxId) + 1;
                  sCustomerId = customerId.toString().padStart(5,'0');
                  this.solarPowerForm.patchValue({
                    refCode : "SOL" + sCustomerId
                  });
                  

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }


   getPreviousData(){
    let filteredList = this.solarPowerData;
    this.solarPowerForm.patchValue({
      fromDate : moment(filteredList[0].ToDate).format("YYYY-MM-DD"),
      fromTime : filteredList[0].ToTime,
      fromSunbirdMR : filteredList[0].ToSunbirdMR,
      fromEBMRExport : filteredList[0].ToEBMRExport,
      fromEBMRConsume : filteredList[0].ToEBMRConsume
    });

  
   }

  isNumeric(value){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }



   calculateAmounts(){
    let productionDiff =null;
    let exportDiff =null;
    let consumeDiff =null;
    let netExportOrConsume =null;

    if(this.solarPowerForm.value.fromSunbirdMR && 
      this.isNumeric(this.solarPowerForm.value.fromSunbirdMR) && 
      this.solarPowerForm.value.toSunbirdMR && 
      this.isNumeric(this.solarPowerForm.value.toSunbirdMR)){
        productionDiff = this.solarPowerForm.value.toSunbirdMR - this.solarPowerForm.value.fromSunbirdMR;

    }

    if(this.solarPowerForm.value.fromEBMRExport && 
      this.isNumeric(this.solarPowerForm.value.fromEBMRExport) && 
      this.solarPowerForm.value.toEBMRExport && 
      this.isNumeric(this.solarPowerForm.value.toEBMRExport)){

        exportDiff = this.solarPowerForm.value.toEBMRExport - this.solarPowerForm.value.fromEBMRExport;

    }

    if(this.solarPowerForm.value.fromEBMRConsume && 
      this.isNumeric(this.solarPowerForm.value.fromEBMRConsume) && 
      this.solarPowerForm.value.toEBMRConsume && 
      this.isNumeric(this.solarPowerForm.value.toEBMRConsume)){

        consumeDiff = this.solarPowerForm.value.toEBMRConsume - this.solarPowerForm.value.fromEBMRConsume;

    }

    if(this.isNumeric(exportDiff) && this.isNumeric(consumeDiff)){
      netExportOrConsume = exportDiff - consumeDiff;
    }

  
    this.solarPowerForm.patchValue({
      productionDiff : productionDiff,
      exportDiff : exportDiff,
      consumeDiff :  consumeDiff,
      netExportOrConsume : netExportOrConsume,
    });

   }

  saveButtonClick(): void {
    var data : any;
    
    this.logValidationErrors(this.solarPowerForm,true);
    const formData = this.mapFormValuesToCustomerModel();  

          if(this.isFilledFromFields()){
            
              if(!this.solarPowerForm.value.id){
                this.showProcessingIndicator = true;
                this.solarPowerMgtService.create(formData)
                .subscribe(
                  (res) => {

                              if(res.success === 0){
                                this.solarPowerForm.patchValue({
                                refCode : res.autoId
                                });
                              this.saveButtonClick();
                              this.showProcessingIndicator = false; 
                              
                              }else if(res.success === 1){
                                data=res;
                                this.toastr.success('Record added successfully','Success'); 
                                this.showProcessingIndicator = false; 
                                this.isShowAttachBtn = true;
                                this.newButtonClick()
                             }   

                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                   

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.solarPowerMgtService.update(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Record updated successfully','Success');    
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

  

   enableForm():void{
    Object.keys(this.solarPowerForm.controls).forEach(key => {
      this.solarPowerForm.controls[key].enable();
      //console.log(key)
    });
  }


  disableForm():void{
    Object.keys(this.solarPowerForm.controls).forEach(key => {
      this.solarPowerForm.controls[key].disable();   
    });
  }


  
  logValidationErrors(group: FormGroup = this.solarPowerForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.solarPowerForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

  mapFormValuesToCustomerModel(){
    let formData ={
      ...this.solarPowerForm.value,
      fromDate : moment(this.solarPowerForm.value.fromDate).format("YYYY-MM-DD"),
      toDate : moment(this.solarPowerForm.value.toDate).format("YYYY-MM-DD"),
      createdBy : this.authService.getUserLoggedIn(),
    }

    return formData;
    
  }
   



viewData(data){

  this.solarPowerForm.patchValue({
    id : data.Id,
    refCode:data.RefCode,
    fromDate:data.FromDate ? moment(data.FromDate).format("YYYY-MM-DD"): null,
    fromTime:data.FromTime,
    fromSunbirdMR:data.FromSunbirdMR,
    fromEBMRExport:data.FromEBMRExport,
    fromEBMRConsume:data.FromEBMRConsume,
    toDate:data.ToDate ?  moment(data.ToDate).format("YYYY-MM-DD"): null,
    toTime:data.ToTime,
    toSunbirdMR:data.ToSunbirdMR,
    toEBMRExport:data.ToEBMRExport,
    toEBMRConsume:data.ToEBMRConsume,
    productionDiff:data.ProductionDiff,
    exportDiff:data.ExportDiff,
    consumeDiff:data.ConsumeDiff,
    netExportOrConsume:data.NetExportOrConsume,
    roomDetails:data.RoomDetails,
    totalGuest:data.TotalGuest,
    createdBy:data.CreatedBy,

   
  })

  this.isShowAttachBtn = true; 
}

getDataTableRowData(){
  var data  = this.solarPowerMgtService.dataRow;
  if(data){
    this.viewData(data);
  }
  else{
    this.newButtonClick()
  }
  
                       
}

}//end class
